import { render, staticRenderFns } from "./BloqueNewsletter.vue?vue&type=template&id=774e2454&scoped=true"
import script from "./BloqueNewsletter.vue?vue&type=script&lang=js"
export * from "./BloqueNewsletter.vue?vue&type=script&lang=js"
import style0 from "./BloqueNewsletter.vue?vue&type=style&index=0&id=774e2454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774e2454",
  null
  
)

export default component.exports